/* eslint-disable react/display-name */
import React, { memo } from  'react';
import styled from 'styled-components';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

interface KeyIndicatorItemType {
    Icon: React.ElementType;
    keyString: string;
    valueString: string;
    showBorderBottom?: boolean;
}

export const KeyIndicatorItem = withScreenSize(memo(({
    Icon,
    keyString,
    valueString,
    showBorderBottom = true
}: KeyIndicatorItemType) => {
    return (
        <Container showBorderBottom={showBorderBottom}>
            <OutdoorSportsIconWrapper>
                <Icon/>
            </OutdoorSportsIconWrapper>
            <KeyIndicatorKeyText>{keyString}</KeyIndicatorKeyText>
            <KeyIndicatorValueText>{valueString}</KeyIndicatorValueText>
        </Container>
    );
}));

const Container = styled.div.attrs((props: {showBorderBottom: boolean;}) => props)`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #555555;
    border-bottom: ${(props) => props.showBorderBottom ? '1px solid #EEEEEE': '' };
`;

const OutdoorSportsIconWrapper = styled.div`
    width: 40px;
    margin: 9px 0 0 10px;
`;

export const KeyIndicatorKeyText = styled.div`
    margin: 13px 0 0 10px;
`;

export const KeyIndicatorValueText = styled.div`
    margin: 13px 10px 0 auto;
`;
